import { useSelector } from 'react-redux'
import { Tabs } from '../../components';
import { getLocalized } from '../../redux/localization';
import Contracts from './contracts';
import OpenContracts from './activeContracts';
import PendingContracts from './pendingContracts';
import ClosedContracts from './closedContracts';

const ContractPage = () => {

  const localize = useSelector(getLocalized);
  return (
    <Tabs key="Id"
      height={850}
      children={[
        {
          title: localize.getString("contracts"),
          component: <Contracts />,
        },
        {
          title: localize.getString("activeContracts"),
          component: <OpenContracts />,
        },
        {
          title: localize.getString("pendingContracts"),
          component: <PendingContracts title={localize.getString("pendingContracts")}/>,
        },
        {
          title: localize.getString("closedContracts"),
          component: <ClosedContracts />,
        },
      ]}
    />
  )
}

export default ContractPage